<au-body-text [text]="nameDescriptionList()[value] || '' | translate" />
